import {
  clearIngressServiceEventDetails,
  fetchIngressServiceEventFail,
  fetchIngressServiceEventStarted,
  fetchIngressServiceEventSuccess
} from '../../../reducer/services/ServiceIngressEventReducer';
import { fetchServiceEvent } from '../../actionType/services/ServiceEventActionTypes';
import {
  ClearServiceEvent,
  FetchServiceEventFailure,
  FetchServiceEventFailurePayload,
  FetchServiceEventRequest,
  FetchServiceEventStarted,
  FetchServiceEventSuccess,
  FetchServiceEventSuccessPayload
} from '../../types/services/GetAllServiceEventTypes';

export const fetchServiceEventRequest = (eventName: string, status: string, eventType: string): FetchServiceEventRequest => ({
  type: fetchServiceEvent.FETCH_SERVICE_EVENT_REQUEST,
  eventName,
  status,
  eventType
});

/**
 * Fetch service event started saga action
 * @returns service event started action
 */
export const getServiceEventStarted = (): FetchServiceEventStarted => ({
  type: fetchIngressServiceEventStarted.type
});

/**
 * Fetch service event success saga action
 * @param payload : Service Event data
 * @returns success action
 */
export const getServiceEventSuccess = (
  payload: FetchServiceEventSuccessPayload
): FetchServiceEventSuccess => ({
  type: fetchIngressServiceEventSuccess.type,
  payload
});

/**
 * Fetch Service Event Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const fetchServiceEventFailure = (
  payload: FetchServiceEventFailurePayload
): FetchServiceEventFailure => ({
  type: fetchIngressServiceEventFail.type,
  payload
});

/**
 * Clear Service Events saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const clearIngressServiceEvent = (): ClearServiceEvent => ({
  type: clearIngressServiceEventDetails.type
});
